<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="分类管理" name="1">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <div class="search-left-top">
            <el-form-item label="医家名：">
              <el-input v-model="formInline.name"></el-input>
            </el-form-item>
            <el-form-item label="朝代：">
              <el-select v-model="formInline.dynasty_id">
                <el-option
                  v-for="item in dynastyClass"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分类：">
              <el-select v-model="formInline.category_id">
                <el-option
                  v-for="item in categoryClass"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出处：">
              <el-input v-model="formInline.from"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <!-- 标题 -->
        <div class="title">
          <div>名医列表</div>
          <el-button type="primary" @click="getDefault()">查询</el-button>
        </div>
        <el-table :data="minyiData" style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" align="center">
          </el-table-column>
          <el-table-column prop="dynasty_id" label="朝代ID" align="center">
          </el-table-column>
          <el-table-column prop="dynasty" label="朝代" align="center">
          </el-table-column>
          <el-table-column prop="name" label="朝代名" align="center">
          </el-table-column>
          <el-table-column
            prop="name_initial"
            label="首字母简拼"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="category_id"
            label="分类ID"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="category_name"
            label="分类名称"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row, 1)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="totalPages > 1">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="currentPage"
            :page-size="page_size"
            :total="pageTotal"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="朝代列表" name="2">
        <!-- 标题 -->
        <div class="title">
          <div>朝代列表</div>
          <el-button type="primary" @click="add()">新增</el-button>
        </div>
        <el-table :data="dynastysData" style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" align="center">
          </el-table-column>
          <el-table-column prop="name" label="名称" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row, 2)"
                >编辑</el-button
              >
              <el-button type="text" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <!-- 编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
      :title="editTitle"
      center
    >
      <el-form ref="ruleForm" :model="form" label-width="180px">
        <el-form-item label="朝代ID：">
          <el-select v-model="form.dynasty_id" class="handle-select">
            <el-option
              v-for="item in dynastyClass"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医生名：">
          <el-input type="text" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="医生简拼：">
          <el-input type="text" v-model="form.name_initial"></el-input>
        </el-form-item>
        <el-form-item label="分类ID：">
          <el-select v-model="form.category_id" class="handle-select">
            <el-option
              v-for="item in categoryClass"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="简介：">
          <el-input type="text" v-model="form.introduce"></el-input>
        </el-form-item>
        <el-form-item label="标签：">
          <div
            v-for="(item, i) in form.labels"
            :key="i"
            style="margin-bottom: 10px;display: flex;align-items: center;"
          >
            <el-select v-model="item.type" class="handle-select">
              <el-option
                v-for="(child, index) in bqList"
                :key="index"
                :label="child.label"
                :value="child.value"
              ></el-option>
            </el-select>
            <el-input
              type="text"
              v-model="item.title"
              style="width:200px;margin-left: 10px;margin-right: 10px;"
            ></el-input>
            <el-button type="primary" @click="delBq(i)">删 除</el-button>
          </div>
          <el-button type="primary" @click="addBq">添 加</el-button>
        </el-form-item>
        <el-form-item label="名医图片：">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="form.full_img_path"
              :src="form.full_img_path"
              class="avatar"
              alt="加载失败"
            />
            <em
              v-show="!form.full_img_path && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm')"
          >保 存</el-button
        >
        <el-button type="primary" @click="editVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑弹出框 -->
    <el-dialog
      :visible.sync="editDynastyVisible"
      width="50%"
      :close-on-click-modal="false"
      :title="editTitle"
      center
    >
      <el-form ref="ruleForm" :model="dynastyForm" label-width="180px">
        <el-form-item label="朝代名：">
          <el-input type="text" v-model="dynastyForm.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit()">保 存</el-button>
        <el-button type="primary" @click="editVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/zkApiConfig";
import http2 from "../../../api/uploadApiConfig";
import md5 from "js-md5";
export default {
  data() {
    return {
      activeName: "1",
      id: "",
      imageUrl: "",
      editVisible: false,
      editDynastyVisible: false,
      editTitle: "名医详情页",
      loading: false,
      formInline: {},
      form: {},
      dynastyForm: {},
      minyiData: [],
      dynastysData: [],
      //   分页
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 10,
      dynastyClass: [],
      categoryClass: [],
      uploading: false,
      // 标签
      labels: "",
      bqList: [
        {
          value: "1",
          label: "书名",
        },
        {
          value: "2",
          label: "书目",
        },
        {
          value: "3",
          label: "作者",
        },
        {
          value: "4",
          label: "科室",
        },
        {
          value: "5",
          label: "医生",
        },
        {
          value: "6",
          label: "出处",
        },
        {
          value: "7",
          label: "疾病",
        },
        {
          value: "9",
          label: "功效",
        },
        {
          value: "10",
          label: "经络",
        },
        {
          value: "11",
          label: "朝代",
        },
        {
          value: "12",
          label: "方剂名",
        },
        {
          value: "13",
          label: "中药名称",
        },
        {
          value: "14",
          label: "经穴名称",
        },
      ],
      is_add: false,
      dynastys_id: "",
      dynasty_id: "",
    };
  },
  mounted() {
    this.getDefault();
    this.getData();
  },
  methods: {
    addBq() {
      var newItem = { bq_name: "", leiMu: "" };
      this.form.labels.push(newItem);
    },
    delBq(i) {
      this.form.labels.splice(i, 1);
    },
    getDefault() {
      if (this.activeName == "1") {
        this.loading = true;
        let params = {
          page: this.currentPage,
          page_size: this.page_size,
          name: this.formInline.name,
          category_id: this.formInline.category_id,
          dynasty_id: this.formInline.dynasty_id,
        };
        http.get("/admin/zsk/doctor_list", { params: params }).then((res) => {
          if (res.data.status_code == 200) {
            this.minyiData = res.data.data.data;
            this.currentPage = Number(res.data.data.current_page);
            this.totalPages = res.data.data.last_page;
            this.pageTotal = this.totalPages * this.page_size;
            this.loading = false;
          }
        });
      } else if (this.activeName == "2") {
        this.loading = true;
        http.get("/admin/zsk/doctor/dynastys").then((res) => {
          if (res.data.status_code == 200) {
            this.dynastysData = res.data.data;
            console.log(this.dynastysData, "this.dynastysData");
            this.loading = false;
          }
        });
      }
    },
    getData() {
      http.get("/admin/zsk/doctor/dynastys").then((res) => {
        if (res.data.status_code == 200) {
          this.dynastyClass = res.data.data;
        }
      });
      http.get("/admin/zsk/doctor/categorys").then((res) => {
        if (res.data.status_code == 200) {
          this.categoryClass = res.data.data;
        }
      });
    },
    // 搜索
    search() {},
    // 编辑
    edit(row, type) {
      if (type == 1) {
        this.editVisible = true;
        this.id = row.id;
        http.get("/admin/zsk/doctor/" + row.id).then((res) => {
          if (res.data.status_code == 200) {
            this.form = res.data.data;
            this.form.introduce = res.data.data.details.introduce;
            this.form.full_img_path = res.data.data.details.full_img_path;
            this.form.img_path = res.data.data.details.img_path;
            console.log(this.form, "form");
          }
        });
      } else if (type == 2) {
        console.log(row, "rrr");
        this.is_add = false;
        this.editDynastyVisible = true;
        this.dynastyForm = row;
        this.dynastys_id = row.id;
      }
    },
    add() {
      this.is_add = true;
      this.dynastyForm = {};
      this.editDynastyVisible = true;
    },
    // 提交
    saveEdit() {
      if (this.activeName == "1") {
        let that = this;
        // 标签处理
        let labels = that.form.labels;
        let data = "";
        var data1 = "";
        for (let i = 0; i < labels.length; i++) {
          data = labels[i].type + "_" + labels[i].title + ",";
          that.form.labels += data;
        }
        data1 = data1.substring(0, data1.length - 1);
        let params = {
          name: that.form.name,
          category_id: that.form.category_id,
          dynasty_id: that.form.dynasty_id,
          name_initial: that.form.name_initial,
          img_path: that.imageUrl,
          labels: data1,
          introduce: that.form.introduce,
        };
        http.put("/admin/zsk/doctor/" + that.id, params).then((res) => {
          if (res.data.status_code == 200) {
            that.$message.success("已保存");
            this.getDefault();
            this.editVisible = false;
          } else {
            that.$message.error(res.data.msg);
          }
        });
      } else if (this.activeName == "2") {
        if (this.is_add == true) {
          let params = this.dynastyForm;
          http.post("/admin/zsk/dynasty", params).then((res) => {
            if (res.data.status_code == 200) {
              this.$message.success("新增成功");
              this.getDefault();
              this.editDynastyVisible = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          let params = this.dynastyForm;
          http
            .put("/admin/zsk/dynasty/" + this.dynastys_id, params)
            .then((res) => {
              if (res.data.status_code == 200) {
                this.$message.success("编辑成功");
                this.getDefault();
                this.editDynastyVisible = false;
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
        console.log(2);
      }
    },
    del(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("/admin/zsk/dynasty/" + row.id).then((res) => {
            if (res.data.status_code == 200) {
              that.getDefault();
              that.$message.success("删除成功");
            } else {
              that.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 选项卡
    handleClick(tab) {
      if (tab.index == 1) {
        this.getDefault();
      } else if (tab.index == 2) {
        this.getDefault();
      }
    },
    // 图片上传
    beforeAvatarUpload(file) {
      console.log(file, "file");
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        let fileNames = file.name.split("/")[0];
        var time = new Date().getTime();
        var filename = md5(time + fileNames) + "." + imgType;
        ossData.append("work_path", "mediawiki/doctors");
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        http2.post("upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.imageUrl = "mediawiki/doctors/" + filename;
            that.form.img_path = "mediawiki/doctors/" + filename;
            that.form.img_path = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 时间
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getDefault();
    },
    // 上下架
    isShelf(row) {
      this.id = row.id;
      this.is_shelf = row.is_shelf;
      this.isShelfDialog = true;
    },
  },
};
</script>

<style scoped>
.header-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.button {
  height: 40px;
  position: absolute;
  right: 28px;
  z-index: 999;
}
.title {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/deep/#tab-1-1 {
  width: 200px !important;
}
/deep/#tab-1-2 {
  width: 200px !important;
}
/deep/.el-tabs__item {
  width: 300px !important;
  text-align: center;
}
/deep/.is-active {
  border-bottom-color: #409eff !important;
}
/deep/.el-table__header {
  width: 100% !important;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
</style>
